import { Modal, Button } from '@shared/ui';
import './ErrorModal.css';

interface ErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    errorMessage: string;
}

export default function ErrorModal({ isOpen, onClose, errorMessage }: ErrorModalProps) {
    return (
        <Modal
            size={400}
            isOpen={isOpen}
            onClose={onClose}
            title="Ошибка"
        >
            <div className="error-modal-content">
                <p>{errorMessage}</p>
                <div className="error-modal-actions">
                    <Button onClick={onClose} fullWidth>ОК</Button>
                </div>
            </div>
        </Modal>
    );
}

